import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Padlock = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M16.25 9.625V7.125C16.25 4.77779 14.3472 2.875 12 2.875C9.65279 2.875 7.75 4.77779 7.75 7.125V9.625M12 13.875V16.875M6.75 21.125H17.25C18.3546 21.125 19.25 20.2296 19.25 19.125V11.625C19.25 10.5204 18.3546 9.625 17.25 9.625H6.75C5.64543 9.625 4.75 10.5204 4.75 11.625V19.125C4.75 20.2296 5.64543 21.125 6.75 21.125Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 2.125C9.23858 2.125 7 4.36358 7 7.125V8.875H6.75C5.23122 8.875 4 10.1062 4 11.625V19.125C4 20.6438 5.23122 21.875 6.75 21.875H17.25C18.7688 21.875 20 20.6438 20 19.125V11.625C20 10.1062 18.7688 8.875 17.25 8.875H17V7.125C17 4.36358 14.7614 2.125 12 2.125ZM15.5 8.875V7.125C15.5 5.192 13.933 3.625 12 3.625C10.067 3.625 8.5 5.192 8.5 7.125V8.875H15.5ZM12 13.125C12.4142 13.125 12.75 13.4608 12.75 13.875V16.875C12.75 17.2892 12.4142 17.625 12 17.625C11.5858 17.625 11.25 17.2892 11.25 16.875V13.875C11.25 13.4608 11.5858 13.125 12 13.125Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
